// src/components/blog/AllTagsDisplay.js
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { blogPostsData } from '../../data/blogPostsData';
import { slugify } from '../../utils/helpers'; // Assure-toi que ce chemin est correct
import './AllTagsDisplay.css';

function AllTagsDisplay({ posts }) {
  const { tagSlug: activeTagSlug } = useParams(); // Récupère le slug du tag actif depuis l'URL

  const sourcePosts = Array.isArray(posts) ? posts : blogPostsData;

  // Extrait tous les tags uniques de tous les articles
  const allTags = sourcePosts.reduce((acc, post) => {
    if (post.tags) {
      post.tags.forEach(tag => {
        if (!acc.includes(tag)) {
          acc.push(tag);
        }
      });
    }
    return acc;
  }, []);

  // Trie les tags par ordre alphabétique (optionnel)
  allTags.sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));

  if (allTags.length === 0) {
    return null;
  }

  return (
    <nav className="all-tags-display-container" aria-label="Filtrer les articles par tag">
      {/* <h3>Explorer par Tags :</h3> */}
      <ul className="tags-list">
        {/* Ajoute un lien pour "Tous les articles" */}
        <li>
          <Link 
            to="/blog" 
            className={`tag-link-item ${!activeTagSlug ? 'active-tag' : ''}`}
          >
            Tous les articles
          </Link>
        </li>
        {allTags.map(tag => {
          const currentSlug = slugify(tag);
          return (
            <li key={tag}>
              <Link 
                to={`/blog/tag/${currentSlug}`} 
                className={`tag-link-item ${activeTagSlug === currentSlug ? 'active-tag' : ''}`}
              >
                {tag}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default AllTagsDisplay;